export default __webpack_public_path__ + "static/media/latest-drops-1.e53fdc41.png";